<template>
    <div></div>
</template>

<script>

    import Vue from 'vue'
    import {mapMutations,mapActions} from 'vuex'

    export default {
        name: 'logout',
        components: {

        },
        data: () => ({

        }),

        methods: {
            ...mapMutations({
                showLoading: 'UI/showLoading',
                logout: 'Auth/logout',
            }),

            ...mapActions({
                callLogout: 'Auth/logout',
            })

        },

        created(){
            this.callLogout()
                .then(() => {
                    this.logout();
                    Vue.googleAuth().signOut(function(){},function(){})
                    this.$router.replace({name:'Login'});
                })


        },

        mounted(){



        },
        updated(){


        },
        beforeRouteUpdate (to, from, next) {


            next();
        },
    }
</script>

<style lang="scss">




</style>



// WEBPACK FOOTER //
// src/views/Logout.vue